import { createStore } from "vuex";

export const store = createStore({
	state: {
		session: {}
	},
	mutations: {
		setSession(state: any, session) {
			state.session = session;
		},
		clearSession(state: any) {
			state.session = null;
		}
	},
	actions: {
		updateSession({ commit }, session) {
			commit('setSession', session);
		},
		clearSession({ commit }) {
			commit('clearSession');
		}
	},
	getters: {
		getSession: state => state.session
	}
});